import { render, staticRenderFns } from "./reset-password-init-form.vue?vue&type=template&id=c01a6e4c&"
import script from "./reset-password-init-form.vue?vue&type=script&lang=js&"
export * from "./reset-password-init-form.vue?vue&type=script&lang=js&"
import style0 from "./reset-password-init-form.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports